import app from 'flarum/forum/app';
import { getServiceWorkerRegistration } from './registerServiceWorker';
import addPushNotifications from './push/addPushNotifications';
import showOptInAlert from './push/showOptInAlert';
import clearAppBadge from './push/clearAppBadge';
import { pushConfigured, supportsWebPush } from './push/utils';
import { syncPushSubscription } from './push/subscription';
import { usingAppleWebview } from './native/appleWebView';
import { isIOSStandalone } from './utils/platforrm';
export { default as extend } from './extend';
app.initializers.add('fof-pwa', () => {
  addPushNotifications();
  clearAppBadge();
  app.beforeMount(async () => {
    if ('share' in navigator && app.forum.attribute('fofPwaShareButtons')) {
      const {
        default: addShareControls
      } = await import(/* webpackChunkName: 'forum/share/addShareControls', webpackMode: 'lazy-once' */ './share/addShareControls');
      addShareControls();
    }
    if (usingAppleWebview()) {
      const {
        default: addFirebasePushNotifications
      } = await import(/* webpackChunkName: 'forum/native/addFirebasePushNotifications', webpackMode: 'lazy-once' */ './native/addFirebasePushNotifications');
      addFirebasePushNotifications();
    }
    showOptInAlert();
    void getServiceWorkerRegistration().then(registration => {
      if (!registration || !supportsWebPush() || !pushConfigured() || Notification.permission !== 'granted') {
        return;
      }
      return syncPushSubscription(registration);
    }).catch(error => {
      console.error('[fof-pwa] SW initialization failed:', error);
    });
    if (isIOSStandalone()) {
      const {
        default: addPullToRefresh
      } = await import(/* webpackChunkName: 'forum/addPullToRefresh', webpackMode: 'lazy-once' */ './addPullToRefresh');
      addPullToRefresh();
    }
  });
});flarum.reg.addChunkModule('689', '328', 'fof-pwa', 'forum/share/addShareControls');
flarum.reg.addChunkModule('165', '129', 'fof-pwa', 'forum/native/addFirebasePushNotifications');
flarum.reg.addChunkModule('797', '485', 'fof-pwa', 'forum/addPullToRefresh');
flarum.reg.addChunkModule('689', '328', 'fof-pwa', 'forum/helpers/url');
flarum.reg.addChunkModule('797', '485', 'fof-pwa', 'forum/components/PullToRefreshIndicator');